module.exports = __webpack_public_path__ + "img/img-9.cc99f2a5.png";